import type { SVGProps } from 'react';
import * as React from 'react';

const ZipIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={40} height={44} viewBox="0 0 40 44" fill="none" aria-hidden="true" {...props}>
    <g id="file-icon/zip">
      <g id="Vector" filter="url(#filter0_dd_3816_38085)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2256 1L35.3367 10.1111V38.3333C35.3367 39.8061 34.1538 41 32.681 41C27.0175 41 13.7476 41 7.33006 41C5.8573 41 4.67004 39.82 4.67004 38.3473C4.67004 30.3468 4.67004 10.7752 4.67004 3.6498C4.67004 2.17704 5.86395 1 7.33671 1H26.2256Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2256 1L35.3367 10.1111V38.3333C35.3367 39.8061 34.1538 41 32.681 41C27.0175 41 13.7476 41 7.33006 41C5.8573 41 4.67004 39.82 4.67004 38.3473C4.67004 30.3468 4.67004 10.7752 4.67004 3.6498C4.67004 2.17704 5.86395 1 7.33671 1H26.2256Z"
          fill="url(#paint0_radial_3816_38085)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2256 1L26.2255 7.44444C26.2255 8.9172 27.4194 10.1111 28.8921 10.1111L35.3367 10.1111L26.2256 1Z"
          fill="#F3F4F6"
        />
      </g>
      <g id="Union">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.9226 28.7012H22.323L23.2224 34.7012L22.0222 36.8018H18.4226L17.2224 34.7012L18.1228 28.7012H17.5222V26.9014H22.9226V28.7012ZM20.2224 33.2012C19.5599 33.2013 19.0225 33.7389 19.0222 34.4014C19.0225 35.0639 19.5599 35.6015 20.2224 35.6016C20.8849 35.6013 21.4224 35.0638 21.4226 34.4014C21.4223 33.739 20.8848 33.2014 20.2224 33.2012Z"
          fill="#9CA3AF"
        />
        <path
          d="M21.1228 18.501H22.9226V20.001H21.1228V21.501H22.9226V23.001L22.323 25.4014H18.1218L17.5222 23.001H19.322V21.501H17.5222V20.001H19.322V18.501H17.5222V17.001H21.1228V18.501Z"
          fill="#9CA3AF"
        />
        <path
          d="M21.1228 12.5H22.9226V14H21.1228V15.5H22.9226V17H19.322V15.5H17.5222V14H19.322V12.5H17.5222V11H21.1228V12.5Z"
          fill="#9CA3AF"
        />
      </g>
      <g id="border">
        <path
          d="M7.33704 1.5H26.0187L34.837 10.3184V38.333C34.837 39.5323 33.8747 40.5 32.6808 40.5H7.3302C6.20668 40.5 5.2908 39.6581 5.18079 38.5684L5.17004 38.3477V3.64941C5.17025 2.4571 6.1364 1.5 7.33704 1.5Z"
          stroke="black"
          strokeOpacity={0.06}
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_dd_3816_38085"
        x={2.67004}
        y={0}
        width={34.6666}
        height={44}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={0.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3816_38085" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_3816_38085" result="effect2_dropShadow_3816_38085" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3816_38085" result="shape" />
      </filter>
      <radialGradient
        id="paint0_radial_3816_38085"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(20.0034 0.999999) rotate(90) scale(40 40.1825)"
      >
        <stop offset={0.297418} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.03} />
      </radialGradient>
    </defs>
  </svg>
);
export default ZipIcon;
